import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { ConveniosService } from '@providers/convenios.service';
import { ComunService } from '@services/comun.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LandingResolver implements Resolve<{ landingHtml: string }> {
  constructor(
    private conveniosService: ConveniosService,
    private comunService: ComunService
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<{ landingHtml: string }> {
    const cn = route.queryParams?.cn;
    const idConvenio = this.comunService.desencriptar(cn);
    return this.conveniosService.obtenerLanding(idConvenio);
  }
}
